var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full h-12 justify-between px-2 py-3 pb-1 items-center"},[_c('p',{staticClass:"text-md"},[_vm._v(_vm._s(_vm.$t('suggest_account')))]),_c('c-btn',{attrs:{"icon":""},on:{"click":_vm.newRecommended}},[_c('Icon',{staticClass:"text-secondary-500 hover:text-primary",attrs:{"icon":"reload","size":"4"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }